
import {WOW} from '../../../node_modules/wowjs/dist/wow';


$(document).ready(function(){
  let textArr = $('.wowtext')
  $.each(textArr,function(index,value){
    let tempArr = $(value).html().split(' ')
    let texthtml = ``
    let num = 0
    for(let i=0; i<tempArr.length;i++){
      let wordArr = tempArr[i].split('')
      let wordHtml = ``
      for(let j=0; j<wordArr.length;j++){
        num += 1
        wordHtml += `<span class="wow fadeInLeft" data-wow-delay="${num*0.1}s">${wordArr[j]}</span>`
      }
      texthtml += wordHtml+'&nbsp;'
    }

    $(value).html(texthtml)
  })

  new WOW().init();
})

$('.form-item.select input').on('click',function(){
  let $parent = $(this).closest('.select')
  
  if(!$parent.hasClass('hover')){
    $('.form-item.select').removeClass('hover')
    $parent.addClass('hover')
  }else{
    $parent.removeClass('hover')
  }
})

$('.form-item.select ul li').on('click',function(){
  let that = $(this)
  let val = $(this).html()
  that.closest('.select').find('input').val(val)
  that.closest('.select').removeClass('hover')
  
  setTimeout(function(){
    that.addClass('on').siblings().removeClass('on')
  },200)
})

$('body').on('click',function(e){
  if($(e.target).parents('.form-item.select').length == 0){
    $('.form-item.select').removeClass('hover')
  }
})

$('.form-facebook .close-btn').on('click',function(){
  $('.form-facebook').removeClass('active')
})